<template lang="pug">
v-container(fluid).pa-0
  menu-course-type-select.mb-2
  crud-scroll-details(
    ref="list"
    :detailsComponent="detailsComponent"
    :adapter="adapter"
    :multiple="multiple"
  )
    template(#list-header="{ init, unSelect, resetSearch }")
      v-row.mb-2(no-gutters)
        v-col
          v-btn(
            block tile depressed
            :color="tab === 0 ? 'secondary' : ''"
            @click="tab = 0; init(); unSelect(); multiple = false;"
          ) Сформируйте
        v-col
          v-btn(
            block tile depressed
            :color="tab === 1 ? 'secondary' : ''"
            @click="tab = 1; init(); unSelect(); multiple = false;"
          ) Подпишите
        v-col
          v-btn(
            block tile depressed
            :color="tab === 2 ? 'secondary' : ''"
            @click="tab = 2; init(); unSelect(); multiple = false;"
          ) Сформированные
    template(#list-header-bottom="{ indeterminate, selectAll, unSelectAll, isAllSelected }")
      .d-flex.px-3.align-end.py-1(v-if="tab !== 2")
        v-checkbox.pt-0.mt-0.ml-1(
          v-if="multiple"
          :input-value="isAllSelected"
          :indeterminate="indeterminate"
          :label="isAllSelected ? 'Отмена' : 'Выбрать все'"
          hide-details
          @change="$event ? selectAll() : unSelectAll()"
        )
        v-switch.ml-auto(
          v-model="multiple"
          color="secondary"
          rounded
          text
          inset
          :label="`Режим ${ tab ? 'подписания' : 'формирования'}`"
          outlined
          hide-details
        ).pt-0.mt-1
      .d-flex(v-else).px-2.align-center
        v-chip-group(
          v-model="selectedTags"
          active-class="secondary"
          column mandatory
        )
          v-chip(small :value="[4,5]") Все
          v-chip(small :value="5") Выданные
          v-chip(small :value="4") Не выданные
        v-spacer
        v-btn(small depressed  color="secondary" @click="openExport")
          span Выгрузить список
          v-icon(right) mdi-download

    template(#list-item="{ item, active }")
      v-list-item-icon(v-if="!multiple").mr-4
        v-icon( size="28"
        ) mdi-account
      v-list-item-content
        strong {{ item.user.full_name || item.user.name }}
        .text-caption.align-center.d-flex(v-if="item.course")
          v-icon(left small) mdi-book-open-page-variant-outline
          span {{ item.course.short_title}}
        .caption.warning--text(v-if="[1, 2].includes(item.status)")
          v-icon(left small color="warning") mdi-clock-outline
          span Формируется
        .caption(v-else-if="item.serial")
          v-icon(left small) mdi-certificate-outline
          span {{ item.serial }} {{ item.number }}
            |  (ПК {{'0'.repeat(6 - `${item.id}`.length)}}{{item.id}})
      v-list-item-action(v-if="item.downloaded_at"): v-icon(
        color="success"
      ) mdi-account-arrow-down

  portal(to="export.dialog")
    v-card.sdo-card
      v-card-title Выгрузка удостоверений
      v-card-text.pb-0
        v-window.mx-n2.px-2.pb-6(v-model="window")
          v-window-item
            .text-body-2.mb-2: strong Выберите тип выгрузки:
            v-list
              v-list-item-group(v-model="exportType")
                v-list-item.grey.lighten-3.mb-4.py-2(
                  active-class="secondary darken-1 white--text"
                  :value="1"
                )
                  template(#default="{ active }")
                    v-list-item-avatar.mr-2: v-icon(
                      :color="active ? 'white' : 'secondary'"
                    ) {{ !active ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked'}}
                    v-list-item-title: strong Реестр для ФИС ФРДО
                v-list-item.grey.lighten-3.py-2(
                  active-class="secondary darken-1 white--text"
                  :value="2"
                )
                  template(#default="{ active }")
                    v-list-item-avatar.mr-2: v-icon(
                      :color="active ? 'white' : 'secondary'"
                    ) {{ !active ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked'}}
                    v-list-item-title: strong Журнал выдачи удостоверений

            .d-flex.mt-4
              v-spacer
              v-btn(
                depressed large color="success"
                :disabled="!exportType"
                @click="window += 1"
              ).px-8 Продолжить
          v-window-item
            .text-body-2.mb-2: strong Укажите период выгрузки:
            .text-body-2 от:
            sdo-datetime-field(
              v-model="start"
              only-date large
              :date-props="{ height: 60, filled: true, solo: true, flat: true }"
            )
            .text-body-2 до:
            sdo-datetime-field(
              v-model="end"
              only-date :date-props="{ height: 60, filled: true, solo: true, flat: true }"
            )

            .d-flex.mt-4
              v-btn(
                depressed large color=""
                :disabled="!exportType"
                @click="window -= 1"
              ).px-8 Назад
              v-spacer
              v-btn(
                depressed large color="success"
                :loading="loading"
                :disabled="!(start && end)"
                @click="exportList"
              ).px-8 Выгрузить
</template>

<script>
import CrudScrollDetails from '@/components/Global/crudScrollDetails/index.vue';
import CertificateActions from '../components/CertificateActions.vue';
import CertificateDetail from '../components/CertificateDetail.vue';
import MenuCourseTypeSelect from '../components/MenuCourseTypeSelect.vue';

export default {
  components: {
    CrudScrollDetails,
    MenuCourseTypeSelect,
  },
  data() {
    return {
      window: 0,
      tab: 0,
      start: null,
      end: null,
      loading: false,
      exportType: null,
      selectedTags: [4, 5],
      isAllSelected: false,
      multiple: false,
    };
  },
  watch: {
    multiple() {
      this.isAllSelected = false;
    },
    selectedTags() {
      this.$refs.list.refreshList();
    },
  },
  computed: {
    detailsComponent() {
      const component = this.multiple ? CertificateActions : CertificateDetail;
      return {
        component,
        component_attrs: { tab: this.tab },
        component_listeners: {
          unSelect: () => {
            this.$refs.list.unSelect();
            this.$refs.list.refreshList();
            this.multiple = false;
          },
        },
      };
    },
    // query() {
    //   const resulst = {};
    //   return resulst;
    // },
  },

  methods: {
    async exportList() {
      this.loading = true;
      const { start, end, exportType } = this;
      const byType = {
        1: {
          method: 'exportFisFrdo',
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        2: {
          method: 'exportJournal',
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        },
      };
      const { data } = await this.$api.diploma[byType[exportType].method]({ start, end });

      const blob = new Blob([data], { type: byType[exportType].type });
      const objectUrl = URL.createObjectURL(blob);
      window.open(objectUrl);
      this.$modals.close();
      this.loading = false;
    },
    openExport() {
      this.$modals.show('dialog-portal', {
        dialogProps: {
          maxWidth: 800,
        },
        inputValue: 'export',
      });
    },
    signDocument() {},
    selectById(id) {
      this.$refs.list.selectById(id);
    },
    adapter(params) {
      const byTab = {
        0: {
          'search[without_diploma]': 1,
          'search[status]': 4,
          'search[course_type]': 2,
        },
        1: { 'search[status]': [1, 2, 3] },
        2: { 'search[status]': this.selectedTags },
      };
      const method = this.tab ? 'getDiplomas' : 'getPriorRecordUsers';
      return this.$api.diploma[method]({
        expand: 'user,prior_record,group,organization_user,course',
        ...byTab[this.tab],
        ...params,
      });
    },
  },
};
</script>
